import * as React from 'react';
import { AndroidFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { DeliveryChannel } from '../../enums/delivery-channels';
export var NativeAndroidBadge = function NativeAndroidBadge(props) {
  var badge = /*#__PURE__*/React.createElement("span", {
    className: "icon-android"
  }, /*#__PURE__*/React.createElement(AndroidFilled, null));
  return /*#__PURE__*/React.createElement("span", {
    className: "delivery-channel-android-badge"
  }, props.hideTooltip ? badge : /*#__PURE__*/React.createElement(Tooltip, {
    title: props.tooltip || "Delivery Channel: ".concat(DeliveryChannel.getLongName(DeliveryChannel.NATIVE_ANDROID))
  }, badge));
};